import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { Button, Modal } from "antd";
import { ModalConstants } from "../../../../common/Constants";

export interface State {}

export interface Props {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onCancel: any;
  onUpdate: any;
  getCodebook: any;
  Form: any;
  rowData: any;
  codebooks?: any;
}

export default class UpdateModal extends React.Component<Props, State> {
  private formSubmitHandler: any;

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.registerFormSubmitEventHandler = this.registerFormSubmitEventHandler.bind(
      this
    );
  }

  registerFormSubmitEventHandler(registrationHandler) {
    this.formSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const { onUpdate, onCancel } = this.props;
    if (this.formSubmitHandler) {
      let newData = this.formSubmitHandler(e);
      if (newData) {
        onUpdate(newData);
        onCancel();
      }
    }
  }

  render() {
    const {
      translate,
      title,
      visible,
      onCancel,
      Form,
      rowData,
      codebooks,
      getCodebook
    } = this.props;

    return (
      <Modal
        title={title ? title : ""}
        visible={visible}
        onCancel={onCancel}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={onCancel}>
            {translate("modal_functions.update_modal.cancel")}
          </Button>,
          <Button key="submit" type="primary" onClick={this.onSubmit}>
            {translate("modal_functions.update_modal.update")}
          </Button>
        ]}
        width={ModalConstants.WIDTH}
      >
        <Form
          translate={translate}
          registerFormSubmitEventHandler={this.registerFormSubmitEventHandler}
          rowData={rowData}
          codebooks={codebooks}
          getCodebook={getCodebook}
          onCancel={onCancel}
        ></Form>
      </Modal>
    );
  }
}
